import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles } from '../styles/Styles';
import { TextComponent } from './quizzing/TextComponent';
import { ButtonComponent } from './quizzing/ButtonComponent';
import { DateComponent } from '../components/quizzing/DateComponent';
import { SelectComponent } from '../components/quizzing/SelectComponent';
import { ValidationHelper } from '../common/helpers/ValidationHelper';
import { Controller } from '../common/Controller';
import { AppHelper } from '../helpers/AppHelper';

export class ProfileFields extends Component {
  constructor(props) {
    super(props);
    this.profileComplete = AppHelper.isProfileSectionComplete(this.props.currentStep)
    this.state = {
    }
  }

  getFormFieldContent = (formField) => {
    //console.log('getFormFieldContent', this.props.responseByQuestionId[formField.id])
    if (formField.type === 'TEXT-SHORT' || formField.type === 'INT' || formField.type === 'FLOAT') {
      return (
        <div key={formField.id} className={css(Styles.profileFieldContainer)}>
          <TextComponent
            mainTitle={formField.title}
            data={formField}
            value={this.props.responseByQuestionId[formField.id]}
            handleState={this.props.handleState}
            survey={false}
            disabled={this.profileComplete || formField.disabled}
            enableValidation={true}
            key={formField.id} />
        </div>
      )
    } else if (formField.type === 'DATE') {
      return (
        <div key={formField.id} className={css(Styles.profileFieldContainer)}>
          <DateComponent
            disableFuture={true}
            mainTitle={formField.title}
            data={formField}
            value={this.props.responseByQuestionId[formField.id]}
            handleState={this.props.handleState}
            survey={false}
            disabled={this.profileComplete}
            enableValidation={true}
            key={formField.id} />
        </div>
      )
    } else if (formField.type === 'OPTIONS-SELECT') {
      return (
        <div key={formField.id} className={css(Styles.profileFieldContainer)}>
          <SelectComponent
            mainTitle={formField.title}
            data={formField}
            value={this.props.responseByQuestionId[formField.id]}
            handleState={this.props.handleState}
            survey={false}
            disabled={this.profileComplete}
            enableValidation={true}
            key={formField.id} />
        </div>
      )
    }
  }

  generateContent = () => {
    let leftFieldsCounter = 0
    let rightFieldsCounter = 0
    let fullLengthFieldsCounter = 0
    const fieldsTemplate = []

    for (const formField of this.props.formFields) {
      if (formField.placement === 'left') {
        fieldsTemplate.push(this.getFormFieldContent(formField))
        leftFieldsCounter = leftFieldsCounter + 1
      } else if (formField.placement === 'right') {
        fieldsTemplate.push(this.getFormFieldContent(formField))
        rightFieldsCounter = rightFieldsCounter + 1
      } else if (formField.placement === 'full') {
        fieldsTemplate.push(this.getFormFieldContent(formField))
        fullLengthFieldsCounter = fullLengthFieldsCounter + 1
      }
    }

    let oneSide = false
    if (leftFieldsCounter === 0 || rightFieldsCounter === 0) {
      oneSide = true
    }

    return (
      <div className={css(Styles.fieldsOuterContainer)}>
        {fieldsTemplate.length > 0 &&
          <div className={oneSide ? css(Styles.fieldsContainerCol) : css(Styles.fieldsContainerRow)}>
            {fieldsTemplate}
          </div>
        }
      </div>
    )
  }

  onSubmit = () => {
    this.validateFieldsAndSubmit()
  }

  validateFieldsAndSubmit() {
    let valid = true
    for (const formField of this.props.formFields) {
      if (ValidationHelper.validateFields(formField, this.props.responseByQuestionId[formField.id])) {
        valid = false
      }
    }
    if (valid) {
      this.props.nextStepper()
    }
  }

  render() {
    return (
      <div className={css(CommonStyles.stepperInnerContainer)}>
        <p className={css(CommonStyles.stepperTitleContent)}>{this.props.title}</p>
        <div className={css(CommonStyles.stepperContent)}>
          {this.generateContent()}
        </div>
        {!AppHelper.isProfileSectionComplete(this.props.currentStep) &&
          <div className={css(CommonStyles.buttonContainer)}>
            <ButtonComponent
              label='NEXT'
              inProcess={this.props.inProcess}
              onSelect={this.onSubmit}
            />
          </div>
        }
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  gridOuterContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  fieldsOuterContainer: {
    padding: 20,
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    '@media (max-width: 767px)': {
      padding: 0,
    }
  },
  fieldsContainerRow: {
    //padding: 20,
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '@media (max-width: 767px)': {
      padding: 0,
    }
  },
  fieldsContainerCol: {
    //padding: 20,
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 767px)': {
      padding: 0,
    }
  },
  profileFieldContainer: {
    width: '40%',
    paddingLeft: '2.5%',
    paddingRight: '2.5%',
    '@media (max-width: 767px)': {
      padding: 0,
      width: '100%',
    }
  },
})


// WEBPACK FOOTER //
// ./src/components/ProfileFields.js